import { OwaDate } from 'owa-datetime';
import emailRemindersStore from '../store/store';

export default function getCustomReminderDate(): OwaDate {
    return emailRemindersStore.customReminderDate;
}
